//=================================================
// Accordions
//=================================================
import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

export function setupAccordions() {
    document.querySelectorAll('.accordion').forEach((el) => {
        if (initializeOnce(el)) {
            const clickableArea = el.querySelector('.accordion__short');
            const toggle = el.querySelector('.accordion__toggle');

            clickableArea.addEventListener('click', () => {
                const expanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', String(!expanded));
                el.classList.toggle('active', !expanded);
            });
        }
    });
}
